module.exports = __webpack_public_path__ + "assets/teams-eb754b76fee1ad58cbfe37600a289d99.svg";